


























import Vue from "vue";
import { get } from "lodash-es";
import { formatNumber } from "@/utils/index"
export default Vue.extend({
  props: ["config", "special"],
  filters: {
    formatNumber
  },
  computed: {
    list() {
      return get(this.config, "list", []);
    },
    information() {
      return get(this.config, "information", "");
    },
    maintitle() {
      return get(this.config, "title[0]", "");
    },
    subtitle() {
      return get(this.config, "title[1]", "");
    }
  }
});
